<template>
    <div>
        <b-row>
            <b-col align-h="center" cols="12" md="6" lg="6">
                <app-form-select-input
                    label="Estructura"
                    :options="accessPoints"
                    v-model="satisfactionPoll.structureId"
                    :required="true"
                    :hasError="$v.satisfactionPoll.structureId.$error"
                    errorMessage="Debe seleccionar el punto de acceso"
                    @input="$v.satisfactionPoll.structureId.$touch()"
                />
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <app-form-text-input
                    label="Persona que responde encuesta"
                    id="answeredBy"
                    :required="true"
                    :hasError="$v.satisfactionPoll.answeredBy.$error"
                    errorMessage="Debe escribir el nombre de la persona que responde la encuesta"
                    @input="$v.satisfactionPoll.answeredBy.$touch()"
                    v-model="satisfactionPoll.answeredBy"
                >
                </app-form-text-input>
            </b-col>
            <b-col cols="12" md="6" lg="5">
                <app-autocomplete
                    placeholder="Modalidad"
                    :items="modes"
                    v-model="satisfactionPoll.selectedMode"
                />
            </b-col>
            <b-col cols="12" md="6" lg="3">
                <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="newMode"
                    v-b-toggle.collapse-3
                    class="btn-block"
                    >Otra modalidad</b-button
                >
            </b-col>
            <b-col cols="12" md="12" lg="4">
                <b-collapse id="collapse-3">
                    <b-col cols="12" md="12" lg="12">
                        <app-form-text-input
                            placeholder="Nombre modalidad"
                            id="modeName"
                            :required="true"
                            :hasError="$v.satisfactionPoll.modeName.$error"
                            errorMessage="Debe escribir el nombre de la modalidad"
                            @input="$v.satisfactionPoll.modeName.$touch()"
                            v-model="satisfactionPoll.modeName"
                        >
                        </app-form-text-input>
                    </b-col>
                    <br />
                </b-collapse>
            </b-col>
            <b-col cols="12" md="12" lg="6">
                <br />
                <app-form-textarea-input
                    label="Aspectos por mejorar"
                    id="improovementAspect"
                    v-model="satisfactionPoll.improovementAspect"
                />
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <br />
                <app-form-textarea-input
                    label="Aspectos positivos"
                    id="positiveAspect"
                    v-model="satisfactionPoll.positiveAspect"
                />
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <br />
                <app-form-textarea-input
                    label="Mejora de la empresa"
                    id="companyImproovement"
                    v-model="satisfactionPoll.companyImproovement"
                />
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <br />
                <app-form-textarea-input
                    label="Información de Visita"
                    id="callInformation"
                    v-model="satisfactionPoll.callInformation"
                />
            </b-col>
        </b-row>
        <b-card
            title="Cuestionario"
            tag="article"
            style="max-width: 100%;"
            class="mb-2"
        >
            <div class="card-text">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        v-for="(question, i) in questions"
                        :key="i"
                    >
                        <label> {{ question.name }}:</label><br />
                        <b-col cols="12" md="6">
                            <div
                                class="btn-group"
                                role="group"
                                aria-label="..."
                            >
                                <b-btn
                                    :variant="
                                        !isSelected(question.id, i)
                                            ? 'secondary'
                                            : 'success'
                                    "
                                    v-for="i in 5"
                                    :key="i"
                                    @click="setQuestion(question.id, i)"
                                    >{{ i }}</b-btn
                                >
                            </div>
                        </b-col>
                        <b-col
                            v-if="
                                !!getFieldValue(question.id) &&
                                    getFieldValue(question.id) <= 2
                            "
                        >
                            <label for=""
                                >Explique el por que de su calificación
                                baja</label
                            >
                            <textarea
                                :value="getFieldValueJustification(question.id)"
                                class="form-control"
                                @change="
                                    setQuestionJustification(
                                        question.id,
                                        $event.target.value
                                    )
                                "
                            />
                        </b-col>
                        <hr />
                    </b-col>
                </b-row>
                <b-col>
                    <div class="errors" v-if="errors.length > 0">
                        <ul>
                            <li v-for="error in errors">
                                <span class="field-error">{{ error }}</span>
                            </li>
                        </ul>
                    </div>
                </b-col>
            </div>
        </b-card>
    </div>
</template>
<script>
import Autocomplete from "../../../../../../components/UI/Controls/AutocompleteV2/Autocomplete.vue";
import satisfactionPollRepository from "../../../../../../repositories/satisfactionPoll.repository";
import structuresRepository from "../../../../../../repositories/structures.repository.js";
import { required } from "vuelidate/lib/validators";
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    props: {
        theClientId: {
            required: true
        },
        theReportId: {
            required: false
        },
        onSave: {
            type: Function
        }
    },
    watch: {
        "satisfactionPoll.selectedMode"(val) {
            if (val) {
                this.satisfactionPoll.modeName = val.name;
                this.isNewMode = false;
            } else {
                this.isNewMode = true;
            }
        }
    },
    data() {
        return {
            satisfactionPoll: {
                selectedMode: "",
                modeName: "",
                answeredBy: "",
                improovementAspect: "",
                positiveAspect: "",
                companyImproovement: "",
                callInformation: "",
                structureId: ""
            },
            isNewMode: false,
            accessPoints: [],
            modes: [],
            questions: [],
            answers: [],
            errors: []
        };
    },
    validations: {
        satisfactionPoll: {
            modeName: { required },
            answeredBy: { required },
            structureId: { required }
        }
    },
    methods: {
        loadModes() {
            const spr = { ...satisfactionPollRepository };
            spr.loadSatisfactionPollModes()
                .then(({ data }) => (this.modes = data))
                .catch(error =>
                    toastr.error("Error al cargar las modalidades")
                );
        },
        loadQuestions() {
            const spr = { ...satisfactionPollRepository };
            spr.loadSatisfactionPollQuestions()
                .then(({ data }) => (this.questions = data))
                .catch(error => toastr.error("Error al cargar las preguntas"));
        },
        loadAccessPoints() {
            const sr = { ...structuresRepository };
            sr.accessPointsByClient(this.theClientId)
                .then(data => {
                    const newAccessPoints = [];
                    data.map(item => {
                        const accessPoint = {
                            ...item,
                            name: item.name + " (" + item.venue.name + ")"
                        };
                        newAccessPoints.push(accessPoint);
                    });
                    this.accessPoints = newAccessPoints;
                })
                .catch(error =>
                    toastr.error("Error al cargar los puntos de acceso")
                );
        },
        saveSatisfactionPoll() {
            if (!this.validateForm()) return false;
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const formData = new FormData();

            formData.append("clientId", this.theClientId);
            formData.append("structureId", this.satisfactionPoll.structureId);
            formData.append("reportedById", this.user.id);
            formData.append("answeredBy", this.satisfactionPoll.answeredBy);
            formData.append(
                "contactReportId",
                !!this.theReportId ? this.theReportId : ""
            );
            formData.append(
                "improovementAspect",
                this.satisfactionPoll.improovementAspect
            );
            formData.append(
                "positiveAspect",
                this.satisfactionPoll.positiveAspect
            );
            formData.append(
                "callInformation",
                this.satisfactionPoll.callInformation
            );
            formData.append(
                "companyImproovement",
                this.satisfactionPoll.companyImproovement
            );

            formData.append("isNewMode", !!this.isNewMode ? 1 : 0);
            if (!this.isNewMode) {
                formData.append(
                    "modeId",
                    this.satisfactionPoll.selectedMode.id
                );
            } else {
                formData.append("modeName", this.satisfactionPoll.modeName);
            }

            if (!!this.answers.length) {
                this.answers.forEach((item, index) => {
                    Object.keys(item).forEach(key =>
                        formData.append(`answers[${index}][${key}]`, item[key])
                    );
                });
            }

            const spr = { ...satisfactionPollRepository };
            spr.saveSatisfactionPoll(formData)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanFields();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "Error al guardar la encuesta de satisfacción"
                    );
                });
        },
        validateForm() {
            this.errors = [];
            // Validar que se hayan contestado todas las preguntas
            this.answers.length < this.questions.length &&
                this.errors.push("Debe Contestar todas las preguntas");

            return !this.errors.length;
        },
        cleanFields() {
            Object.keys(this.satisfactionPoll).map(
                key => (this.satisfactionPoll[key] = "")
            );
            this.isNewMode = false;
            this.answers = [];
            this.errors = [];
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        newMode() {
            this.isNewMode = true;
            this.satisfactionPoll.selectedMode = "";
            this.satisfactionPoll.modeName = "";
        },
        setQuestion(questionId, answer) {
            let current = this.answers.findIndex(
                item => item.questionId === questionId
            );
            if (current !== -1) {
                this.answers[current].answer = answer;
            } else {
                let answ = {
                    questionId,
                    answer: answer
                };
                this.answers.push(answ);
            }
        },
        getFieldValue(questionId) {
            if (this.answers.length) {
                return !!this.answers.find(
                    item => item.questionId === questionId
                )
                    ? this.answers.find(item => item.questionId === questionId)
                          .answer
                    : "";
            }
        },
        setQuestionJustification(questionId, justification) {
            let current = this.answers.findIndex(
                item => item.questionId === questionId
            );
            if (current !== -1) {
                this.answers[current].justification = justification;
            } else {
                let answ = {
                    questionId,
                    justification: justification
                };
                this.answers.push(answ);
            }
        },
        getFieldValueJustification(questionId) {
            if (this.answers.length) {
                const answer = this.answers.find(
                    item => item.questionId === questionId
                );
                return !!answer && !!answer.justification
                    ? answer.justification
                    : "";
            }
        },
        isSelected(questionId, answerId) {
            return !!this.answers.find(
                item =>
                    item.questionId === questionId && item.answer === answerId
            );
        },
        inialize() {
            this.loadModes();
            this.loadQuestions();
            this.loadAccessPoints();
        }
    },
    created() {
        this.inialize();
        this.$bus.$on("satisfaction-poll.save", this.saveSatisfactionPoll);
        this.$bus.$on("satisfaction-poll.clean", this.cleanFields);
    }
};
</script>
